export const breakpoints = { xs: 0, sm: 767, md: 1023, lg: 1279, xl: 1899 };
